import $ from 'jquery';
import Swiper from 'swiper';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/modal';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { EasePack } from 'gsap/EasePack';
gsap.registerPlugin(ScrollTrigger, EasePack);

'use strict';

const headerMarginAuto = () => {
  $(window).on('resize load', function () {
    let h = $('#header').innerHeight();
    $('.hma').css('margin-top', h)
    $('.hpa').css('padding-top', h)
  });
}

const hamuMenuScripts = () => {
  $('#ham-menu').on('click', function () {
    if ($('.ham-parts').hasClass('is_set')) {
      $('.ham-parts').removeClass('is_set');
    } else {
      $('.ham-parts').addClass('is_set');
    }
  })
}

const scrollAnime = () => {
  let sectionContents = document.querySelectorAll('.sectionContent');
  Array.prototype.forEach.call(sectionContents, function (sectionContent) {
    gsap.fromTo(sectionContent, { x: 0, y: 50, autoAlpha: 0 }, {
      scrollTrigger: {
        trigger: sectionContent,
        start: 'top 80%',
        once: true,
        // markers: {
        //   startColor: 'blue',
        //   endColor: 'blue',
        //   fontSize: '18px',
        //   fontWeight: 'bold',
        //   indent: 20
        // },
      },
      duration: 2,
      x: 0,
      y: 0,
      autoAlpha: 1,
      ease: 'circ.out',
      overwrite: 'auto',
    })
  });

  let logoContents = document.querySelectorAll('.logoContent');
  Array.prototype.forEach.call(logoContents, function (logoContent) {
    gsap.fromTo(logoContent, { x: 0, y: 100, autoAlpha: 0 }, {
      scrollTrigger: {
        trigger: logoContent,
        start: 'top 80%',
        once: true,
        // markers: {
        //   startColor: 'blue',
        //   endColor: 'blue',
        //   fontSize: '18px',
        //   fontWeight: 'bold',
        //   indent: 20
        // },
      },
      duration: 2,
      x: 0,
      y: 0,
      autoAlpha: 1,
      ease: 'circ.out',
      overwrite: 'auto',
    })
  });

  ScrollTrigger.create({
    trigger: '.recruitContent',
    start: 'top 80%',
    once: true,
    onEnter: function () {
      $('.recruitContent').delay(500).queue(function () {
        $(this).addClass('is_set').dequeue();
      });
    }
  })

  gsap.to(".fv_slide", 2.5, {
    width: "130%",
    left: "130%",
    delay: 0.4,
    ease: 'circ.out',
  });
  gsap.to(".fv_slide_fig", 1, {
    opacity: 1,
    delay: 0.5
  });

}

const topFvAnime = () => {
  $('.fv-text').delay(1500).queue(function () {
    $(this).addClass('loaded').dequeue();
  });
}

$(() => {
  headerMarginAuto();
  hamuMenuScripts();
  scrollAnime();
  topFvAnime();
});